export * from './ArticleTextNewsFeature';
